import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TokenService } from '../../services/token.service';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core'; import { SharedService } from '../../services/shared.service';


@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [RouterModule, TranslatePipe],
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent {

  @Input() selected: String = ""; // Lista de elementos para el sidebar

  isAdmin: boolean = false;

  constructor(private tokenService: TokenService,
    private sharedService: SharedService
  ) {

  }

  ngOnInit(): void {
    this.validateAdmin();
  }

  nameUser(): string {
    return this.tokenService.obtainNameUser();
  }

  /**
   * Función encargada de validar si es admin ya sea por el evento al refrescar la página lo obtendra del localStorage
   */
  validateAdmin(): void {
    this.sharedService.isAdmin().subscribe({
      next: admin => {
        if (admin) {
          this.isAdmin = admin;
        } else {
          this.isAdmin = JSON.parse(localStorage.getItem('isAdmin') || 'false');
        }
      }
    });
  }
}
